import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Sets `document.title` to a unique, descriptive value for the current page in the form
 * `{companyName} - {pageTitle}`. When `pageTitle` is not provided, the title falls back
 * to the company name only.
 */
export const useDocumentTitle = (pageTitle?: string): void => {
  const { t } = useTranslation();
  const companyName = t("common.appName");

  useEffect(() => {
    document.title = pageTitle ? `${companyName} - ${pageTitle}` : companyName;
  }, [companyName, pageTitle]);
};
